export default __webpack_public_path__ + "static/media/IMG_9722 copie.108926b2.jpg";